export default __webpack_public_path__ + "static/media/gallery_08.75e5d652.jpg";